import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import IMenuItem from '../../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../../common/widgets/mainLayout';
import LanguageUtils from '../../../utils/LanguageUtils';
import { fetchReportHeader, getReportHeaders, isLoadingReportHeader, resetReportHeader } from '../../../reducers/reportsReducer';
import UrlConstants from '../../../constants/UrlConstants';
import Pagination from '../../../interfaces/common/pagination';
import Paging from '../../../interfaces/common/paging';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import PageUtils from '../../../utils/pageUtils';
import ReportHeader from '../../../interfaces/output/ReportHeader';
import ReportHeaderFilters from '../../../interfaces/filters/reportHeaderFilters';
import ReportHeaderFiltersComponent from './reportHeaderFilter';
import ReportHeadersList from './reportHeaderList';

interface IReportHeaderProps {
    classes: any;
    isLoading: boolean;
    onChange: () => void;
    resetReportHeader: () => void;
    fetchReportHeader: any;
    fetch: any;
    reportHeaders: Pagination<ReportHeader>;
    match: any;
}

interface IReportHeaderState {
    filters: ReportHeaderFilters;
    menuItem: IMenuItem;
    paging: Paging;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    reportHeader: LanguageUtils.createMessage('Report header')
    //downloadCSV: LanguageUtils.createMessage('Download CSV')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    // exportKickbackAgreementPostenCSV: (filters: KickbackAgreementFilters) => dispatch(exportKickbackAgreementPostenCSV({
    //     filters
    // })),
    fetchReportHeader: (paging: Paging, filters: ReportHeaderFilters) => dispatch(fetchReportHeader({
        paging,
        filters
    })),
    resetReportHeader: () => dispatch(resetReportHeader())
});

const mapStoreToProps = (store: RootState) => ({
    isLoading: isLoadingReportHeader(store),
    reportHeaders: getReportHeaders(store)
});

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class ReportHeaders extends Component<IReportHeaderProps, IReportHeaderState> {
    reportHeadersRef: any;
    constructor(props: IReportHeaderProps) {
        super(props);

        this.state = {
            filters: {} as ReportHeaderFilters,
            menuItem: {
                id: 1,
                name: messages.reportHeader,
                icon: <FontAwesomeIcon icon="table" size="1x" transform="grow-7" />,
                isSelected: false
            },
            paging: PageUtils.getDefaultPaging([{
                field: 'departureYear',
                sort: 'asc' as GridSortDirection
            } as GridSortItem,
            {
                field: 'departureMonth',
                sort: 'asc' as GridSortDirection
            } as GridSortItem]),
            sortModel: [{
                field: 'departureYear',
                sort: 'asc' as GridSortDirection
            } as GridSortItem,
            {
                field: 'departureMonth',
                sort: 'asc' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchReportHeader } = this.props;
        const { paging, filters } = this.state;
        const { month, year } = this.props.match.params;

        const newFilter = {
            ...filters,
            departureMonth: month,
            departureYear: year
        } as ReportHeaderFilters;

        fetchReportHeader(paging, newFilter);
    }

    componentWillUnmount() {
        const { resetReportHeader } = this.props;
        resetReportHeader();
    }

    // exportCSV = () => {
    //     const { exportKickbackAgreementPostenCSV } = this.props;
    //     const { filters } = this.state;

    //     exportKickbackAgreementPostenCSV(filters);
    // }

    applyFilters = () => {
        const { fetchReportHeader } = this.props;
        const { paging, filters } = this.state;
        const { month, year } = this.props.match.params;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        const newFilter = {
            ...filters,
            departureMonth: month,
            departureYear: year
        } as ReportHeaderFilters;

        this.setState({
            paging: newPagination,
            filters: newFilter
        });

        fetchReportHeader(newPagination, newFilter);

        if(this.reportHeadersRef !== null && this.reportHeadersRef !== undefined &&
            this.reportHeadersRef.current !== null && this.reportHeadersRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeadersRef.current.resetDataGridPage();
        }
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;
        const { month, year } = this.props.match.params;

        const newFilter = { ...filters } as ReportHeaderFilters;
        (newFilter as any)[attribute] = value;
        newFilter.departureMonth = month;
        newFilter.departureYear = year;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    setDefaultState = () => {
        const { fetchReportHeader } = this.props;
        const { paging } = this.state;
        const { month, year } = this.props.match.params;

        const newSortModel = [{
            field: 'id',
            sort: 'asc'
        }] as GridSortModel;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        const newFilters = {
            departureMonth: month,
            departureYear: year
        } as ReportHeaderFilters;

        this.setState({
            filters: newFilters,
            paging: newPagination
        });

        fetchReportHeader(newPagination, newFilters);

        if(this.reportHeadersRef !== null && this.reportHeadersRef !== undefined &&
            this.reportHeadersRef.current !== null && this.reportHeadersRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeadersRef.current.resetDataGridPage();
        }
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchReportHeader } = this.props;
        const { sortModel, filters, paging } = this.state;
        const { month, year } = this.props.match.params;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };
            const newFilter = {
                ...filters,
                departureMonth: month,
                departureYear: year
            } as ReportHeaderFilters;

            this.setState({
                sortModel: newModel,
                paging: newPaging,
                filters: newFilter
            });

            fetchReportHeader(newPaging, newFilter);

        }
    }

    render() {
        const { classes, isLoading, fetchReportHeader, reportHeaders } = this.props;
        const { filters, menuItem, paging, columnVisibilityModel } = this.state;
        const { month, year } = this.props.match.params;

        return (
            <MainLayout menuItem={menuItem}
                routes={
                    [{
                        name: 'go to prev page',
                        url: `${UrlConstants.REPORT_HEADER_PIVOTED}`
                    }]}
            >
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <ReportHeaderFiltersComponent
                                    // actions={[{
                                    //     text: messages.downloadCSV,
                                    //     icon: 'download',
                                    //     onClick: this.exportCSV
                                    // }]}
                                    applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                <ReportHeadersList
                                    rows={reportHeaders} isLoading={isLoading}
                                    ref={this.reportHeadersRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        const newFilter = {
                                            ...filters,
                                            departureMonth: month,
                                            departureYear: year
                                        } as ReportHeaderFilters;
                                        fetchReportHeader(newPage, newFilter);
                                        this.setState({
                                            paging: newPage,
                                            filters: newFilter
                                        });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ReportHeaders));